import { Injectable } from '@angular/core';
import {ConfigService} from "../config/config.service";
import {CompanyInfo} from "./definitions/company-info.interface";

@Injectable({
  providedIn: 'root'
})
export class CompanyInfoService {
  constructor(private configService: ConfigService) { }

  private readonly companyInfos: Record<string, CompanyInfo> = {
    'klobal': {
      name: 'KLOBAL s.r.o.',
      email: 'info@klobal.cz',
      phone: '+420 468 006 300',
      address1: 'Hlaváčova 395',
      address2: '530 02 Pardubice',
      companyId: '25656562',
      vatId: 'CZ25656562',
      cnbLicense: '232288SLPU'
    },
    'vyresime-skodu': {
      name: 'VYŘEŠÍME ŠKODU s.r.o.',
      email: 'info@vyresimeskodu.cz',
      phone: '+420 468 006 555',
      address1: 'Palackého 487',
      address2: '533 03 Dašice',
      companyId: '29755905',
      vatId: 'CZ29755905',
    }
  };

  getCompanyInfo(): CompanyInfo {
    const theme = this.configService.config.theme;
    return this.companyInfos[theme] || this.companyInfos['klobal'];
  }
}
